module.exports = __webpack_public_path__ + "static/media/brasilia-img.591dd98c.jpg";